var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.convention.latestPush)?_c('div',{class:`convention-teaser-alert ${_vm.mode}`},[_c('action',{attrs:{"name":"link"},on:{"click":_vm.openPopin}},[_c('typo',{attrs:{"name":"body-12-light"}},[_vm._v(" Consulter la dernière veille juridique du "+_vm._s(_vm.sentAt)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }